import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/img/jiniantang4.png'
import _imports_1 from '../../../assets/img/xianhua.png'
import _imports_2 from '../../../assets/img/jiniantang1.png'
import _imports_3 from '../../../assets/img/jiniantang2.png'
import _imports_4 from '../../../assets/img/jiniantang3.png'


const _hoisted_1 = { class: "memorialhall" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "message-list" }
const _hoisted_6 = { class: "mt-20" }
const _hoisted_7 = { class: "memoir" }

import {onMounted,ref} from "vue";
import MessageDetail from "@/components/MessageDetail/MessageDetail.vue";
import ScrollImg from "@/components/ScrollImg/ScrollImg.vue";
import wx from "weixin-js-sdk";
import weChatMemorialHallApi from "@/utils/Api/MemorialHall";
import {useRoute} from "vue-router";
import { showNotify } from 'vant';
import commMethods from "@/assets/ts/common";
import obituaryApi from "@/utils/Api/Obituary";
import personobituaryApi from "@/utils/Api/PersonObituary";

export default /*@__PURE__*/_defineComponent({
  __name: 'memorialhall',
  setup(__props) {

const message=ref('');
const route=useRoute();
onMounted(()=>{
  document.title='纪念堂';
  //分享
  commMethods.getTicket(['updateAppMessageShareData','updateTimelineShareData','hideMenuItems'])
  getDetail();



})
const toShare=()=>{
  if(route.query.ismemorial===1) {
    personobituaryApi.share(route.query.id).then(res=>{
      console.log('分享成功')
    })
  }else{
    obituaryApi.share(route.query.id).then(res => {
      console.log('分享成功')
    })
  }

}
const form=ref({
  id:'',
  burningIncenseTotal:0,
  paytributeTotal:0,
  memorialHallSweep:0
});
const imgList=ref([])
const loading=ref(false);
const getDetail=()=> {

  loading.value=true;
  weChatMemorialHallApi.detail(route.query.id).then(res => {

    form.value=res.data;
    imgList.value=res.data.obituaryImgList || []
    wx.ready(()=>{

      wx.updateAppMessageShareData({
        title: form.value.obituaryTitle, // 分享标题
        desc: '', // 分享描述
        // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

        link: 'https://mobile.dqhmbz.com/memorialhall?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:form.value.memorialhallconver, // 分享图标
        success: function () {
          // 设置成功
          console.log(111)
          // toShare();
        },
        fail:(err)=>{
          // showToast({
          //   message:err
          // });
        }
      })

      wx.updateTimelineShareData({
        title: form.value.obituaryTitle, // 分享标题
        // link: 'http://192.168.3.6:81?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致

        link: 'https://mobile.dqhmbz.com/memorialhall?id='+route.query.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl:form.value.memorialhallconver, // 分享图标
        success :()=> {
          // 设置成功
          // toShare();

        }
      })
    })

    getMessage();
  }).finally(() => {
    loading.value=false;
  })
}
const list=ref([]);
const getMessage=()=> {
  weChatMemorialHallApi.getMemorialHallMessagePage(1,form.value.id).then(res => {
    list.value=res.data?.data||[]
  })
}
//上香
const createMemorialBurningIncense=()=> {

  weChatMemorialHallApi.createMemorialBurningIncense({
    "obituaryid": route.query.id,
    "memorialhallid": form.value.id,
    "total": form.value.burningIncenseTotal+1
    //   "id": 0,
  }).then(res => {
    console.log(res)
    getMemrialHallBurningIncenseTotal();
  })
}
const getMemrialHallBurningIncenseTotal=() =>{
  weChatMemorialHallApi.getMemrialHallBurningIncenseTotal(form.value.id).then(res => {
    form.value.burningIncenseTotal=res.data;
  })
}
//上贡
const createMemorialPaytribute=() =>{

  weChatMemorialHallApi.createMemorialPaytribute({
    "obituaryid": route.query.id,
    "memorialhallid": form.value.id,
    "total":  form.value.paytributeTotal+1
    //   "id": 0,
  }).then(res => {
    console.log(res)
    getPaytributeCount();
  })
}
 const getPaytributeCount=() => {
   weChatMemorialHallApi.getPaytributeCount(form.value.id).then(res => {
    form.value.paytributeTotal=res.data;
  })
}
//清扫
const createMemorialHallSweep=() => {
  weChatMemorialHallApi.createMemorialHallSweep({
    "obituaryid": route.query.id,
    "memorialhallid": form.value.id,
    "total":  form.value.memorialHallSweep+1
    //   "id": 0,
  }).then(res => {
    console.log(res)
    getMemrialHallSweepTotal()
  })
}
const getMemrialHallSweepTotal=() =>{
  weChatMemorialHallApi.getMemrialHallSweepTotal(form.value.id).then(res => {
    form.value.memorialHallSweep=res.data;
  })
}
const send=() => {
  loading.value=true;
  weChatMemorialHallApi.create({
    "obituaryid": route.query.id,
    "memorialhallid": form.value.id,
    "messagecontent": message.value,

  }).then(res => {
    console.log(res)
    // wx.showToast({
    //   title: '发送成功',
    // }
    message.value='';
    showNotify({ type: 'success', message: '发送成功,等耐心等待审核' })
    // getMessage();
  }).finally(() => {
    loading.value=false;
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "img1",
        mode: "widthFix",
        src: _imports_0
      }, null, -1)),
      _createElementVNode("img", {
        class: "img2",
        mode: "widthFix",
        src: form.value.memorialhallconver
      }, null, 8, _hoisted_3),
      _cache[5] || (_cache[5] = _createElementVNode("img", {
        class: "img3",
        mode: "widthFix",
        src: _imports_1
      }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "img4",
          onClick: createMemorialBurningIncense
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            mode: "widthFix",
            src: _imports_2
          }, null, -1)),
          _createElementVNode("div", null, _toDisplayString(form.value.burningIncenseTotal), 1)
        ]),
        _createElementVNode("div", {
          class: "img4",
          onClick: createMemorialPaytribute
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            mode: "widthFix",
            src: _imports_3
          }, null, -1)),
          _createElementVNode("div", null, _toDisplayString(form.value.paytributeTotal), 1)
        ]),
        _createElementVNode("div", {
          class: "img4",
          onClick: createMemorialHallSweep
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("img", {
            mode: "widthFix",
            src: _imports_4
          }, null, -1)),
          _createElementVNode("div", null, _toDisplayString(form.value.memorialHallSweep), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "title" }, "祝福留言", -1)),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(MessageDetail, { "data-list": list.value }, null, 8, ["data-list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "回忆录", -1)),
      _createVNode(ScrollImg, { list: imgList.value }, null, 8, ["list"])
    ]),
    _createVNode(_component_van_field, {
      modelValue: message.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
      placeholder: "留言祝福",
      class: "textarea"
    }, null, 8, ["modelValue"]),
    _createElementVNode("button", {
      class: "primary-btn",
      onClick: send
    }, "发送"),
    _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"height":"0.5rem"} }, null, -1))
  ]))
}
}

})